import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  Signal,
  signal,
  viewChild,
  WritableSignal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Client } from '@shared/models';
import { HeaderService } from '@shared/services';
import { ChartsService } from '@shared/services/charts.service';
import { TaxNewsPanel } from '../../models/tax-news-panel';
import { TaxNewsPanelService } from '../../services/tax-news-panel.service';
import { TaxNewsDetailModalComponent } from '../tax-news-detail-modal/tax-news-detail-modal.component';

@Component({
  standalone: false,
  selector: 'gstar-tax-news-panel',
  templateUrl: './tax-news-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxNewsPanelComponent implements OnInit {
  private readonly headerService = inject(HeaderService);
  private readonly taxNewsPanelService = inject(TaxNewsPanelService);
  private readonly chartService = inject(ChartsService);

  taxNewsList: WritableSignal<TaxNewsPanel[] | undefined> = signal([]);
  selectedClient: Signal<Client | undefined> =
    this.headerService.selectedClient.asReadonly();

  selectedTaxNews: WritableSignal<TaxNewsPanel | undefined> = signal(undefined);

  selectedCountryName: WritableSignal<string | undefined> = signal(undefined);

  destroyRef = inject(DestroyRef);

  modal: Signal<TaxNewsDetailModalComponent | undefined> = viewChild(
    TaxNewsDetailModalComponent
  );

  ngOnInit(): void {
    this.taxNewsSubscription();
    this.countryNameSubscription();
  }

  taxNewsSubscription(): void {
    this.taxNewsPanelService.taxNews$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(taxNews => {
        this.taxNewsList.set(taxNews);
      });
  }

  countryNameSubscription(): void {
    this.chartService.selectedCountryName$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(countryName => {
        this.selectedCountryName.set(countryName);
      });
  }

  openTaxNews(taxNews: TaxNewsPanel): void {
    this.selectedTaxNews.set(taxNews);
    this.modal()?.openTaxNewsModal();
  }

  reloadNews(): void {
    this.taxNewsPanelService.reloadNews();
  }
}
